import Header from './HomeHeader.vue';
import Footer from './MafFooter.vue';
import SideBar from './SideBar.vue';
import PhoneMenu from './PhoneMenu.vue';
import GuidePopup from './GuidePopup.vue';
import CustomPopup from './CustomPopup.vue';

const components = [
  Header,
  Footer,
  SideBar,
  PhoneMenu,
  GuidePopup,
  CustomPopup
];

export default components;



// WEBPACK FOOTER //
// ./src/components/home-layout/index.js